import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  fetchInvoicesElectricityFailed,
  fetchInvoicesElectricityRequested,
  fetchInvoicesElectricitySucceeded,
  fetchInvoicesGasFailed,
  fetchInvoicesGasRequested,
  fetchInvoicesGasSucceeded,
  fetchInvoicesWaterFailed,
  fetchInvoicesWaterRequested,
  fetchInvoicesWaterSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* fetchInvoicesElectricityRequest(currentMonth) {
  yield put(fetchInvoicesElectricityRequested(currentMonth));

  try {
    const reportsValue = yield call(request, api.getInvoicesElectricity, currentMonth);
    const action = fetchInvoicesElectricitySucceeded(reportsValue);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchInvoicesElectricityFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchInvoicesWaterRequest(currentMonth) {
  yield put(fetchInvoicesWaterRequested(currentMonth));

  try {
    const reportsValue = yield call(request, api.getInvoicesWater, currentMonth);
    const action = fetchInvoicesWaterSucceeded(reportsValue);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchInvoicesWaterFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchInvoicesGasRequest(currentMonth) {
  yield put(fetchInvoicesGasRequested(currentMonth));

  try {
    const reportsValue = yield call(request, api.getInvoicesGas, currentMonth);
    const action = fetchInvoicesGasSucceeded(reportsValue);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchInvoicesGasFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
